import { Briefcase, ShieldCheck } from "lucide-react"

import type { NavItem } from "@/types"

// Navigation items that appear in the sidebar footer
// Supports both internal and external links with permission controls
export const FOOTER_NAVIGATION_ITEMS: NavItem[] = [
  {
    title: "Admin",
    href: "/admin",
    icon: ShieldCheck,
    external: true,
    target: "_self",
    permission: { requireStaff: true },
  },
  {
    title: "Jobs",
    href: "/jobs",
    icon: Briefcase,
    external: true,
    target: "_self",
    permission: { requireStaff: true },
  },
]
